import {EventModel} from 'models/EventModel'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import {WysiwygType} from 'types'
import {Memoize} from 'util/memoize'

export type StepKey =
	| 'select'
	| 'breakouts'
	| 'configure'
	| 'details'
	| 'gift'
	| 'touring'
	| 'summary'
	| 'onsite'
	| 'badge'

export type StepConfig = {
	breadcrumb: string
	title: string
	text: WysiwygType
	back_btn?: string
	next_btn?: string
}

export abstract class StepModel<C extends StepConfig = StepConfig> {
	registration: RegistrationModel
	config: C

	constructor(registration: RegistrationModel, config: C) {
		this.registration = registration
		this.config = config
	}

	@Memoize()
	get event(): EventModel {
		return this.registration.event
	}

	@Memoize()
	get index(): number {
		return this.registration.steps.findIndex(model => model === this)
	}

	@Memoize()
	get breadcrumb(): string {
		return this.config.breadcrumb
	}

	@Memoize()
	get title(): string {
		return this.config.title
	}

	@Memoize()
	get text(): string {
		return this.config.text
	}

	@Memoize()
	get back_btn(): string {
		return this.config.back_btn
	}

	@Memoize()
	get next_btn(): string {
		return this.config.next_btn
	}

	@Memoize()
	get isLast(): boolean {
		return this.index >= this.registration.steps.length - 1
	}

	@Memoize()
	get isFirst(): boolean {
		return this.index === 0
	}

	@Memoize()
	get nextStepKey(): StepKey {
		if (this.isLast || !this.isReady) return this.key
		return this.registration.steps[this.index + 1].key
	}

	@Memoize()
	get previousStepKey(): StepKey {
		if (this.isFirst) return this.key
		return this.registration.steps[this.index - 1].key
	}

	abstract get key(): StepKey
	abstract get isApplicable(): boolean
	abstract get isReady(): boolean
}
